import { STATIC_PAGES } from './constants'

export const buildExternalLink = (language, market, id) => {
  return `/${STATIC_PAGES[id]}`
}
